/**
 * Bridges iframeManager with the Pressidium Cookie Consent plugin.
 *
 * Requirements:
 * - iframeManager must be loaded
 * - Pressidium Cookie Consent plugin must be active
 *
 * This script:
 * - Syncs iframeManager services with user consent
 * - Prevents iframes from loading before consent is given
 * - Designed to work alongside iframe placeholders generated in PHP.
 *
 * To audit cookies used by embedded services, you can use:
 * - https://themarkup.org/blacklight
 * - https://2gdpr.com/
 * - https://www.cookieyes.com/cookie-checker/
 */

(function (im, pressidium)
{

	'use strict';

	if (!im)
	{
		console.warn('iframeManager not found');
		return;
	}

	if (!pressidium)
	{
		console.warn('Pressidium Cookie Consent not found');
	}

	// Sync iFrameManager with Pressidium Cookie Consent
	const syncAllServices = (event) => {

		// console.log(event);

		// Event received from Pressidium
		const cookie = event.detail?.cookie;
		if (!cookie || !Array.isArray(cookie.categories)) return;

		// Get every service currently registered in iFrameManager (youtube, vimeo, maps, etc.)
		const config = im.getConfig();
		const services = Object.keys(config.services);

		// Loop through every service (youtube, vimeo, maps, etc.)
		services.forEach(service => {
			const serviceConfig = config.services[service];
			const requiredCategories = serviceConfig.categories || [];

			// Check if user accepted 'all' OR every category required for THIS service
			const hasConsent = cookie.categories.includes('all') || requiredCategories.every(cat => cookie.categories.includes(cat));

			hasConsent ? im.acceptService(service) : im.rejectService(service);
		});
	};

	// Listen for Pressidium changes
	window.addEventListener('pressidium-cookie-consent-changed', syncAllServices);
	window.addEventListener('pressidium-cookie-consent-accepted', syncAllServices); // This one also runs on page load


	// iFrameManager config
	function runIframeManager()
	{
		const createNotice = (name, terms) => `
			<div class="im-custom-ui">
				<p>This content is hosted by ${name}. By viewing this, you consent to their
				<a href="${terms}" target="_blank" rel="noreferrer noopener">terms</a> and the use of cookies.</p>
				<button type="button" class="button im-accept-btn" data-accept-all="true">
					Accept All Cookies
				</button>
				<p><a href="#" data-cc="c-settings">Manage Cookie Settings</a></p>
			</div>
		`;

		im.run({
			currLang: 'en',
			services: {
				youtube: {
					categories: ['necessary', 'preferences'],
					embedUrl: 'https://www.youtube-nocookie.com/embed/{data-id}',
					thumbnailUrl: 'https://i3.ytimg.com/vi/{data-id}/hqdefault.jpg',
					iframe: {
						allow: 'accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen;',
						referrerpolicy: 'origin',
						loading: 'lazy'
					},
					languages: {
						en: {
							notice: createNotice('YouTube', 'https://www.youtube.com/t/terms'),
							loadBtn: '',
							loadAllBtn: '',
						}
					}
				},
				vimeo: {
					categories: ['necessary', 'preferences'],
					embedUrl: 'https://player.vimeo.com/video/{data-id}?dnt=1',
					iframe: {
						allow: 'fullscreen; picture-in-picture',
						referrerpolicy: 'origin',
						loading: 'lazy'
					},
					languages: {
						en: {
							notice: createNotice('Vimeo', 'https://vimeo.com/terms'),
							loadBtn: '',
							loadAllBtn: '',
						}
					}
				},
				googlemaps : {
					categories: ['necessary', 'preferences'],
					embedUrl: 'https://www.google.com/maps/embed?pb={data-id}',
					iframe: {
						allow : 'fullscreen',
						referrerpolicy: 'origin',
						loading: 'lazy'
					},
					languages : {
						en : {
							notice: createNotice('Google Maps', 'https://www.google.com/help/terms_maps/'),
							loadBtn: '',
							loadAllBtn: '',
						}
					}
				}
			}
		});
	}


	// Initialize IM
	runIframeManager();


	// New Buttons and Links - Accept All Cookies and Open Pressidium Cookie Consent Settings modal

	document.body.addEventListener('click', (e) => {
		const target = e.target;

		// Accept All Cookies button - button appears in iFrame placeholder
		if (target.closest('[data-accept-all]'))
		{
			if (pressidium)
			{
				pressidium.accept('all');
				pressidium.hide();
			}
		}

		// Open Pressidium Cookie Consent Settings modal - link appears inside iFrame placeholder
		// We must delegate because these buttons are injected dynamically by iFrameManager
		if (target.closest('[data-cc="c-settings"]'))
		{
			if (target.tagName === 'A')
			{
				e.preventDefault();
			}
			if (pressidium?.showSettings)
			{
				pressidium.showSettings();
			}
		}

	});

})(window.iframemanager ? window.iframemanager() : null, window.pressidiumCookieConsent);